import styled from 'styled-components'

export const Container = styled.div`
  margin: 30px 0 20px 0;
  width: 100%;
  @media screen and (max-width: 480px) {
    margin: 10px 0 5px 0;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    margin: 0;
  }
  @media screen and (max-width: 720px) {
  }
  @media screen and (max-width: 480px) {
    flex-direction: column;
    div {
      width: 100%;
      margin: 0 0 2px 0;
    }
  }
`

export const Title = styled.p`
  margin: 0 0 5px 0;
  color: ${({ theme }) => theme.colors.darkPrimary};
`
